import React, { useState } from "react";
import ClipboardInviteLink from "./ClipboardInviteLink";
import ModalUserEdit from "./ModalUserEdit";
import ModalUserDelete from "./ModalUserDelete";
import Notice from "../../Notice";
import UserSearch from "./UserSearch";
import ModalUserInvite from "./ModalUserInvite";

const EntityUsersTable = (props) => {
  const [editingUser, setEditingUser] = useState(null);
  const [deletingUser, setDeletingUser] = useState(null);
  const [displayInviteModal, setDisplayInviteModal] = useState(false);
  const [notice, setNotice] = useState({ kind: "error", open: false, message: "" });
  const [userSearchQuery, setUserSearchQuery] = useState("");

  const { organization_id, entity, users, setUsers } = props;

  const query = userSearchQuery.toLowerCase();
  const filteredUsers = query
    ? users.filter(
        (user) =>
          user.name.toLowerCase().includes(query) || user.email.toLowerCase().includes(query)
      )
    : users;

  return (
    <>
      <div className="details__header__tab_bar align-items-center">
        <UserSearch onSearch={setUserSearchQuery} />
        {props.can_manage_users && (
          <button className="button button--blue" onClick={() => setDisplayInviteModal(true)}>
            Invite New User
          </button>
        )}
      </div>
      <div className="table__container">
        <div className="table__head">
          <div className="table__head__column" style={{ width: 320 }}>
            Name and Email
          </div>
          <div className="table__head__column" style={{ width: 80 }}>
            Status
          </div>
          <div className="table__head__column" style={{ width: 100 }}>
            Role
          </div>
          {props.can_manage_users && (
            <>
              <div className="table__head__column" style={{ width: 210 }}>
                Invite Link
              </div>
              <div className="table__head__column">Actions</div>
            </>
          )}
        </div>

        {filteredUsers.map((user) => (
          <div key={user.id} id={`itemID_${user.id}`} className="table__row">
            <div className="table__row__item" style={{ width: 320 }}>
              <div className="profile__avatar profile__avatar--space-right">
                <div className="profile__avatar__initials">{user.initials}</div>
              </div>
              <div className="profile__details">
                <div className="profile__details__name">{user.name}</div>
                <div className="profile__details__email">{user.email}</div>
              </div>
            </div>
            <div className="table__row__item" style={{ width: 80 }}>
              <div className="tag tag--light-blue">{user.activation_state}</div>
            </div>
            <div className="table__row__item" style={{ width: 100 }}>
              <div className="tag tag--light-blue">{user.role}</div>
            </div>
            {props.can_manage_users && (
              <>
                <div className="table__row__item" style={{ width: 210 }}>
                  {user.activation_state === "pending" && (
                    <ClipboardInviteLink
                      prettyLink={user.vanity_activation_url}
                      value={user.activation_url}
                    />
                  )}
                </div>
                <div className="table__row__item table__actions">
                  {user.id !== props.current_user_id && (
                    <>
                      <div
                        className="btn btn--sq btn--default-align"
                        onClick={() => setEditingUser(user)}
                      >
                        <div className="solid solid-budicon-pen-writing" />
                      </div>
                      <div
                        className="btn btn--sq btn--default-align"
                        onClick={() => setDeletingUser(user)}
                      >
                        <div className="solid solid-budicon-trash" />
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
      {editingUser && (
        <ModalUserEdit
          user={editingUser}
          entity={entity}
          organization_id={organization_id}
          closeModal={() => setEditingUser(null)}
          setUsers={setUsers}
          setNotice={setNotice}
        />
      )}
      {deletingUser && (
        <ModalUserDelete
          user={deletingUser}
          entity={entity}
          organization_id={organization_id}
          closeModal={() => setDeletingUser(null)}
          setUsers={setUsers}
          setNotice={setNotice}
        />
      )}
      {displayInviteModal && (
        <ModalUserInvite
          organization_id={props.organization_id}
          entity={props.entity}
          setUsers={setUsers}
          closeModal={() => setDisplayInviteModal(false)}
          setNotice={setNotice}
          csrfToken={document.querySelector('meta[name="csrf-token"]').getAttribute("content")}
        />
      )}
      <Notice details={notice} />
    </>
  );
};

export default EntityUsersTable;
